<template>
  <div class="section-row">
    <span class="section-row-header">
      {{ headerLabel || resources.pickAnAddressLabel }}
      <a
        @click="openFlyout"
        class="section-link hide-on-mobile"
        title="Select different address"
        >{{ resources.pickAnAddressCTA }}</a
      >
    </span>

    <div class="vertical-tile-list">
        <div v-if="address">
            <address-option-tile
                    :key="address.id"
                    :option="address"
                    :isInFlyin="false"
                    :type="type"
                    :checked="true"
            />
        </div>

      <a
        @click="openFlyout"
        class="section-link hide-on-tablet"
        title="Select different address"
        >{{ resources.pickAnAddressCTA }}</a
      >
    </div>
  </div>
</template>
<script src="./address-picker.js"/>
